import type { Plain } from '../../types';

const plain = (node: Plain) => node.value;

export default plain;
